<template>
  <svg
    class="icon-base"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.75 1.33337C11.4569 1.33337 14.5 4.33572 14.5 8.08337C14.5 11.8112 11.4809 14.8334 7.75 14.8334C4.02362 14.8334 1 11.8158 1 8.08337C1 4.35828 4.01881 1.33337 7.75 1.33337ZM7.75 0.333374C3.47009 0.333374 0 3.80472 0 8.08337C0 12.3645 3.47009 15.8334 7.75 15.8334C12.0299 15.8334 15.5 12.3645 15.5 8.08337C15.5 3.80472 12.0299 0.333374 7.75 0.333374ZM6.625 11.0834H7V7.33337H6.625C6.41791 7.33337 6.25 7.16547 6.25 6.95837V6.70837C6.25 6.50128 6.41791 6.33337 6.625 6.33337H8.125C8.33209 6.33337 8.5 6.50128 8.5 6.70837V11.0834H8.875C9.08209 11.0834 9.25 11.2513 9.25 11.4584V11.7084C9.25 11.9155 9.08209 12.0834 8.875 12.0834H6.625C6.41791 12.0834 6.25 11.9155 6.25 11.7084V11.4584C6.25 11.2513 6.41791 11.0834 6.625 11.0834ZM7.75 3.58337C7.19772 3.58337 6.75 4.03109 6.75 4.58337C6.75 5.13566 7.19772 5.58337 7.75 5.58337C8.30228 5.58337 8.75 5.13566 8.75 4.58337C8.75 4.03109 8.30228 3.58337 7.75 3.58337Z"
    />
  </svg>
</template>
